import { render } from "./requirement_data.vue?vue&type=template&id=9fb5dbd0&scoped=true"
import script from "./requirement_data.vue?vue&type=script&lang=js"
export * from "./requirement_data.vue?vue&type=script&lang=js"

import "./requirement_data.vue?vue&type=style&index=0&id=9fb5dbd0&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb5dbd0"]])

export default __exports__